import {
  CSW_ARROW_CLICK,
  CSW_PRODUCT_CLICK,
  PDP_HIGHER_CSW_NEW_ALGO
} from 'shared/experiments/consts'

import { isExperimentEnabled, trackEvent } from 'shared/experiments/utils'

export default () => {
  if (!isExperimentEnabled(PDP_HIGHER_CSW_NEW_ALGO)) {
    return
  }

  const xSellWidgets = document.querySelectorAll(
    '[data-clientside-api-call~="fetchCrossSell"]'
  )

  xSellWidgets.forEach(xSellWidget => {
    xSellWidget.addEventListener('click', event => {
      const target = <HTMLElement>event.target

      if (target.closest('[data-clientside-hook~="slider__item"]')) {
        trackEvent(CSW_PRODUCT_CLICK)
      }

      if (target.closest('[data-clientside-hook~="adaptable__arrows"]')) {
        trackEvent(CSW_ARROW_CLICK)
      }
    })
  })
}
